export default __webpack_public_path__ + "static/media/sidebar-3.65d851a2.jpg";